// src/components/RoleGate.jsx
import { useAuth } from "../context/AuthContext";

const RoleGate = ({ permission, children, fallback = null }) => {
  const { checkAccess } = useAuth();

  // If user has access, render the protected content
  if (checkAccess(permission)) {
    return children;
  }

  // Otherwise, render nothing (or the fallback UI)
  return fallback;
};

export default RoleGate;